import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { getPXLLoginRoute } from "../../router/routes/pxl/factory/general";

const LoginRequired = ({ children, to }) => {
    const user = useSelector(state => state.user.user);
    const location = useLocation();

    if (user) {
        return <>{children}</>;
    }

    const returnTo = encodeURIComponent(location.pathname + location.search + location.hash);
    const redirectTo = to ?? (getPXLLoginRoute() + '?return_to=' + returnTo);

    return <Navigate to={redirectTo} replace />;
};

export default LoginRequired;